if (!customElements.get('gift-message')) {
  customElements.define(
    'gift-message',
    class GiftMessage extends HTMLElement {
      constructor() {
        super();

        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.giftMessageButton = this.querySelector('button[name="gift-message-button"]');
        this.giftMessageSave = this.querySelector('button[name="gift-message-save"]');
        this.giftMessageEdit = this.querySelector('button[name="gift-message-edit"]');
        this.giftMessageCancel = this.querySelector('button[name="gift-message-cancel"]');
        this.giftMessageRemove = this.querySelector('button[name="gift-message-remove"]');
        this.giftMessageInputWrapper = this.querySelector('.gift-message-input');
        this.giftMessageInput = this.giftMessageInputWrapper.querySelector('textarea');
        this.giftMessageDisplayValue = this.querySelector('.gift-message-property-value');

        if (this.giftMessageButton) {
          this.giftMessageButton.addEventListener('click', this.onGiftMessageClickHandler.bind(this));
        }

        if (this.giftMessageEdit) {
          this.giftMessageEdit.addEventListener('click', this.onGiftMessageEditHandler.bind(this));
        }

        if (this.giftMessageRemove) {
          this.giftMessageRemove.addEventListener('click', this.onGiftMessageRemoveHandler.bind(this));
        }
        
        this.giftMessageCancel.addEventListener('click', this.onGiftMessageCancelHandler.bind(this));
        this.giftMessageSave.addEventListener('click', this.onUpdateHandler.bind(this));
      }

      onGiftMessageCancelHandler() {
        this.giftMessageInputWrapper.classList.toggle("hidden");

        if (this.giftMessageEdit) {
          this.giftMessageEdit.parentElement.classList.toggle("hidden");
        }

        if (this.giftMessageButton) {
          this.giftMessageButton.classList.toggle("hidden");
        }

        if (this.giftMessageDisplayValue) {
          this.giftMessageDisplayValue.classList.toggle("hidden");
        }
      }

      onGiftMessageEditHandler() {
        this.giftMessageEdit.parentElement.classList.toggle("hidden");

        this.giftMessageInputWrapper.classList.toggle("hidden");

        if (this.giftMessageDisplayValue) {
          this.giftMessageDisplayValue.classList.toggle("hidden");
        }

        if (!this.giftMessageInputWrapper.className.includes("hidden")) {
          this.giftMessageInput.focus();
          this.giftMessageInput.selectionStart = this.giftMessageInput.value.length;
        }
      }

      onGiftMessageClickHandler(event) {
        this.giftMessageButton.classList.toggle("hidden");
        this.giftMessageInputWrapper.classList.toggle("hidden");
      }

      onGiftMessageRemoveHandler() {
        event.preventDefault();
        event.stopPropagation();

        if (this.giftMessageRemove.getAttribute('aria-disabled') === 'true') return;

        this.giftMessageRemove.setAttribute('aria-disabled', true);
        this.giftMessageRemove.classList.add('loading');
        this.closest('.cart-item').querySelector('.loading__spinner').classList.remove('hidden');

        const cartChangeData = {
          id: this.dataset.key,
          properties : {},
          sections: this.cart.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname,
        }

        const groupId = this.dataset.groupId;

        if (groupId !== "") {
          cartChangeData.properties["_group_id"] = groupId;
        }

        fetch(`${routes.cart_change_url}`, {
          ...fetchConfig(),
          body: JSON.stringify(cartChangeData)
        })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          if (parsedState.errors) {
            console.log('parsedState.errors', parsedState.errors);
            return;
          }
  
          const cartBubble = document.querySelector('#cart-icon-bubble');
          const stickyNavSwitchedButton = document.querySelector('.sticky-nav__element--show');
  
          if (stickyNavSwitchedButton && parsedState.item_count === 0 && !window.location.pathname.includes('/products/') && !window.location.pathname.includes('/collections/')) {
            stickyNavSwitchedButton.classList.remove('hidden');
            cartBubble.classList.add('sticky-nav__element--hide');
          }
  
          this.cart.renderContents(parsedState);
  
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: undefined });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.giftMessageRemove.classList.remove('loading');
          this.giftMessageRemove.removeAttribute('aria-disabled');
          this.closest('.cart-item').querySelector('.loading__spinner').classList.add('hidden');
        });
      }

      onUpdateHandler(event) {
        event.preventDefault();
        event.stopPropagation();

        if (this.giftMessageSave.getAttribute('aria-disabled') === 'true') return;

        this.giftMessageSave.setAttribute('aria-disabled', true);
        this.giftMessageSave.classList.add('loading');
        this.closest('.cart-item').querySelector('.loading__spinner').classList.remove('hidden');

        const cartChangeData = {
          id: this.dataset.key,
          properties : {},
          sections: this.cart.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname,
        }

        const groupId = this.dataset.groupId;
        const giftMessageInput = this.giftMessageInput.value;

        if (groupId !== "") {
          cartChangeData.properties["_group_id"] = groupId;
        }

        if (giftMessageInput !== "") {
          cartChangeData.properties["Gift Message"] = giftMessageInput;
        }

        fetch(`${routes.cart_change_url}`, {
          ...fetchConfig(),
          body: JSON.stringify(cartChangeData)
        })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          if (parsedState.errors) {
            console.log('parsedState.errors', parsedState.errors);
            return;
          }
  
          const cartBubble = document.querySelector('#cart-icon-bubble');
          const stickyNavSwitchedButton = document.querySelector('.sticky-nav__element--show');
  
          if (stickyNavSwitchedButton && parsedState.item_count === 0 && !window.location.pathname.includes('/products/') && !window.location.pathname.includes('/collections/')) {
            stickyNavSwitchedButton.classList.remove('hidden');
            cartBubble.classList.add('sticky-nav__element--hide');
          }
  
          this.cart.renderContents(parsedState);
  
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: undefined });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.giftMessageSave.classList.remove('loading');
          this.giftMessageSave.removeAttribute('aria-disabled');
          this.closest('.cart-item').querySelector('.loading__spinner').classList.add('hidden');
        });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
